export default __webpack_public_path__ + "static/media/Dead Sea Scrolls - All Souls Deuteronomy_04.d8757b17.jpg";